__turbopack_context__.v({
  "B2BPersonalDataForm": "_6S5GOW_B2BPersonalDataForm",
  "Card": "_6S5GOW_Card",
  "DataForm": "_6S5GOW_DataForm",
  "Headline": "_6S5GOW_Headline",
  "InputRow": "_6S5GOW_InputRow",
});
